export const SET_CONTACT_ATTRIBUTES = 'SET_CONTACT_ATTRIBUTES';
export const ADD_TO_CONTACT_ATTRIBUTE_CACHE = 'ADD_TO_CONTACT_ATTRIBUTE_CACHE';
export const UPDATE_CONTACT_ATTRIBUTE_IN_CACHE = 'UPDATE_CONTACT_ATTRIBUTE_IN_CACHE';
export const ARCHIVE_CONTACT_ATTRIBUTE_IN_CACHE = 'ARCHIVE_CONTACT_ATTRIBUTE_IN_CACHE';
